import { Components, Theme } from '@mui/material';

export const buildMuiTooltipComponent = (): Components<Omit<Theme, 'components'>>['MuiTooltip'] => ({
  styleOverrides: {
    tooltip: ({ theme }) => ({
      background: theme.palette.primary.main,
      opacity: '0.8 !important',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '10px 16px',
      gap: '10px',
      wordBreak: 'break-word',
    }),
  },
  defaultProps: {},
});
